import { Field, Select } from '../ui/Input';

export function VatRateSelect({ value, onChange, disabled }: { value: string; onChange: (value: string) => void; disabled?: boolean }) {
  const selected = value === '0' || value === '20' ? value : '';
  return (
    <Field label="VAT %">
      <Select className="w-full md:w-28" value={selected} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
        <option value="">None</option>
        <option value="0">0</option>
        <option value="20">20</option>
      </Select>
    </Field>
  );
}
